import axios from "@/plugins/axios";

let url = (data) => "/api/v1/company/lectures/${_lecture}/watches".interpolate(data);

export const watches = {
    gets(data) {
        return axios.get(url(data), data).then((result) => result.data);
    },
};

export default watches;
